import { render, staticRenderFns } from "./ConfirmLeaveModal.vue?vue&type=template&id=8baf4e02&"
import script from "./ConfirmLeaveModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmLeaveModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports